import React, {
    Component
} from 'react'
import {
    Link,
    NavLink
} from 'react-router-dom'

import fetch from '~/utils/fetch';
import { actionTypes } from '~/constants';

import _ from 'lodash-joins';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import ListSubheader from '@material-ui/core/ListSubheader';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';


class ModalSimpleModal extends Component {
    constructor() {
        super()

        this.initialState = {
            user_id: null,
            error: null,
        }

        this.state = {...this.initialState};
    }

    handleSubmit(e) {
        e.preventDefault();
        const report_id = this.props.match.params.report_id;
        const report = this.props.reports.list.find(x=>x._id===report_id);
        const user = this.props.users.list.find(x=>x.cognitoId===this.state.user_id);
        if(!user){
            throw new Error(`User cognitoId=${this.state.user_id} not found!`);
        }
        console.log(report)
        console.log(user)
        this.props.dispatch({
            type: actionTypes.REPORTS_UPDATE_ONE,
            id: report._id,
            data: {
                ...report,
                reporter: user.cognitoId,
                reporterEmail: user.email,
            }
        })
        this.props.closeModal();
    }

    handleClick(user_id, e){
        this.setState({
            user_id: user_id,
        })
    }

    render() {
        let users = this.props.users.list;

        // group by department id
        users = _.groupBy(users, u=>u.clientId);

        let departments = this.props.departments.list;
        departments = departments.map(d=>({
            ...d,
            _users: _.get(users, [d._id], []),
        }))

        return (
            <form className="modal-reports-assign-user modal" onSubmit={this.handleSubmit.bind(this)}>
                <input type="submit" style={{display: 'none'}}/>
                <div className="modal-header">
                    <div className="modal-title">
                        Assign User
                    </div>
                    <a onClick={this.props.closeModal} className="modal-dismiss">
                        <img src={`/dist/assets/img/ic-close.svg`}/>
                    </a>
                </div>
                <div className="modal-content">
                    <div className="instructions">
                        Internal Only reports can be assigned to other departments and/or users.
                    </div>
                        <FormControl>
                            {departments.map(department=>(
                                <React.Fragment>
                                    <ListSubheader disableGutters disableSticky>{department.name}</ListSubheader>
                                    {department._users.map(user=>(
                                        <MenuItem
                                            value={user.cognitoId}
                                            selected={this.state.user_id === user.cognitoId}
                                            style={{fontSize: '0.7rem'}}
                                            onClick={this.handleClick.bind(this, user.cognitoId)}
                                        >
                                            {user.firstname} {user.lastname}
                                            &nbsp;
                                            <span style={{color: '#424242'}}>
                                                &lt;{user.email}&gt;
                                            </span>
                                        </MenuItem>
                                    ))}
                                </React.Fragment>
                            ))}
                        </FormControl>

                </div>
                <div className="modal-footer">
                    <div onClick={this.handleSubmit.bind(this)} className="button button-primary">
                        Submit
                    </div>
                </div>
            </form>
        )
    }
}

import { connect } from 'react-redux'
export default connect(
    (state)=>{
        return {
            users: state.users,
            departments: state.departments,
            reports: state.reports,
        }
    },
    (dispatch)=>{
        return {
            dispatch: dispatch
        }
    }
)(ModalSimpleModal);